module.exports = __webpack_public_path__ + "img/royal.33b568c3.png";